"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVueRuntimeContext = void 0;
var vue_1 = require("./vue");
Object.defineProperty(exports, "getVueRuntimeContext", { enumerable: true, get: function () { return vue_1.getVueRuntimeContext; } });
//# sourceMappingURL=index.js.map